import React from 'react'

import phoneMask from '@galo-monitor/forms/masks/phone.mask'
import TextField from '@galo-monitor/web-components/TextField'

const InputPhone = (props) => (
  <TextField
    { ...props }
    type="tel"
    setMask={ phoneMask }
  />
)

export default InputPhone
